export default __webpack_public_path__ + "static/media/5-min.51160e27.jpg";